import { render, staticRenderFns } from "./PatientLayout.vue?vue&type=template&id=bce88486"
import script from "./PatientLayout.vue?vue&type=script&lang=js"
export * from "./PatientLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports